export class CriteriaQuery {
  private _paginationCriteria: PaginationCriteria = {
    Count: 250,
    Offset: '1',
  };
  private _filterCriteria: Map<string, Filter> = new Map();
  private _sortCriteria: Map<string, SortCriteria> = new Map();
  private _filterConditon: string | null = null;
  private _addtionalparams : Map<'pathParam'|'queryParam',any> = new Map<'pathParam'|'queryParam',any>();

  public addFilterCritertia(
    columnName: string,
    columnType: ColumnType,
    searchType: SearchType,
    {
      ...arg
    }: {
      searchText?: string | string[];
      fromValue?: string;
      toValue?: string;
      dateFrom?: string;
      dateTo?: string;
    }
  ): void {
    if (
      this._filterCriteria.has(columnName) &&
      (arg.searchText === '' ||
        arg.searchText === null ||
        arg.searchText === undefined) &&
      (arg.fromValue === '' ||
        arg.fromValue === null ||
        arg.fromValue === undefined) &&
      (arg.toValue === '' || arg.toValue === null || arg.toValue === undefined)
    ) {
      this._filterCriteria.delete(columnName);
    } else if (
      (arg.searchText !== '' &&
        arg.searchText !== null &&
        arg.searchText !== undefined) ||
      (arg.fromValue !== '' &&
        arg.fromValue !== null &&
        arg.fromValue !== undefined) ||
      (arg.toValue !== '' && arg.toValue !== null && arg.toValue !== undefined)
    ) {
    this._filterCriteria.set(columnName, {
      columnName,
      columnType,
      searchType,
      ...arg,
    });
  } else if (
      (arg.searchText !== '' &&
        arg.searchText !== null &&
        arg.searchText !== undefined) ||
      (arg.dateFrom !== '' &&
        arg.dateFrom !== null &&
        arg.dateFrom !== undefined) ||
      (arg.dateTo !== '' && arg.dateTo !== null && arg.dateTo !== undefined)
    ) {
    this._filterCriteria.set(columnName, {
      columnName,
      columnType,
      searchType,
      ...arg,
    });
  }
}

public removeFilterCriteria(name:string){
  if(this._filterCriteria.has(name)){
    this._filterCriteria.delete(name)
  }
}


  public addSortCriteria(
    columnName: string,
    sortType: SortType,
    columnType: ColumnType
  ): void {
    this._sortCriteria.set(columnName, {
      columnName: columnName,
      orderType: sortType,
      columnType: columnType,
    });
  }
  public setFilterCondition(filterCondition: string): void {
    this._filterConditon = filterCondition;
  }
  public setPaginationCriteria(offset: string, count: number): void {
    this._paginationCriteria.Count = count;
    this._paginationCriteria.Offset = offset;
  }

  public addPathparam(key:string, value: any):void{
    const pathParam = this._addtionalparams.get('pathParam') || {};
    const  obj : {[k:string] : any } = {}
    obj[key] = value ;
    let updatePathParam = {...pathParam, ...obj };
    this._addtionalparams.set('pathParam',updatePathParam);
  }

  public addQueryparam(key:string, value: any):void{
    const queryParam = this._addtionalparams.get('queryParam') || {};
    const  obj : {[k:string] : any } = {}
    obj[key] = value ;
    let updateQueryParam = {...queryParam, ...obj };
    this._addtionalparams.set('queryParam',updateQueryParam);
  }


  public getPathparam(key:string){
    return this._addtionalparams.get('pathParam')?.[key] || ''
  }

  public getQueryparam(key:string){
    return this._addtionalparams.get('queryParam')?.[key] || ''
  }

  public criteriaQuery(): Criteria {
    let filterCriteriaDetail: FilterCriteria[] = [];
    const mapFilterCriteria = [...this._filterCriteria.values()];
    for (let index = 0; index < mapFilterCriteria.length; index++) {
      const filterCriteria: FilterCriteria = {
        columnName: mapFilterCriteria[index].columnName,
        columnType: mapFilterCriteria[index].columnType,
        conditions: {
          searchType: mapFilterCriteria[index].searchType,
          searchText: mapFilterCriteria[index].searchText,
          fromValue: mapFilterCriteria[index].fromValue,
          toValue: mapFilterCriteria[index].toValue,
          dateFrom: mapFilterCriteria[index].dateFrom,
          dateTo: mapFilterCriteria[index].dateTo,
        },
      };
      filterCriteriaDetail.push(filterCriteria);
    }
    let sortCriteriaDetail: SortCriteria[] = [];
    const mapSortCriteria = [...this._sortCriteria.values()];
    for (let i = 0; i < mapSortCriteria.length; i++) {
      const sortCriteria: SortCriteria = {
        columnName: mapSortCriteria[i].columnName,
        columnType: mapSortCriteria[i].columnType,
        orderType: mapSortCriteria[i].orderType,
      };
      sortCriteriaDetail.push(sortCriteria);
    }

    const criteria :any = {
      Offset: this._paginationCriteria.Offset,
      Count: this._paginationCriteria.Count,
    };
    if(this._filterConditon){
      criteria["FilterExpression"] = this._filterConditon
    }
    if( filterCriteriaDetail.length > 0){
      criteria['FilterCriteria'] = filterCriteriaDetail
    }
    if(sortCriteriaDetail.length > 0){
      criteria['OrderCriteria'] = sortCriteriaDetail
    }
    criteria['totalCount']= 'true'; 
    return criteria
  }
}

export interface Criteria {
  Offset: string;
  Count: number;
  FilterExpression?: string | null;
  FilterCriteria: FilterCriteria[];
  OrderCriteria?: SortCriteria[];
}

export interface PaginationCriteria {
  Offset: string;
  Count: number;
}

export interface FilterCriteria {
  columnName: string;
  columnType: ColumnType;
  conditions: {
    searchType: SearchType;
    searchText?: string | string[];
    fromValue?: string;
    toValue?: string;
    dateFrom?: string;
    dateTo?: string;
  };
}

export interface Filter {
  columnName: string;
  columnType: ColumnType;
  searchType: SearchType;
  searchText?: string | string[];
  fromValue?: string;
  toValue?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface SortCriteria {
  columnName: string;
  orderType: SortType;
  columnType: ColumnType;
}

export type ColumnType = 'Date' | 'Timestamp' | 'String' | 'Numeric';

export type SearchType =
  | 'Contains'
  | 'equals'
  | 'notEqual'
  | 'startsWith'
  | 'endsWith'
  | 'greaterThan'
  | 'lessThan'
  | 'greaterThanEquals'
  | 'lessThanEquals'
  | 'inRange'
  | 'isNull'
  | 'isNotNull'
  | 'in';

export type SortType = 'asc' | 'desc';
